import { Component } from '@angular/core';
import { PwaService } from './core/services/pwa.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'MNC Tourism Indonesia';

  showInstallButton = false;

  constructor(private pwaService: PwaService) {}

  ngOnInit() {
    // PWA service sudah otomatis berjalan
    this.checkPwaInstallPrompt();
  }

  checkPwaInstallPrompt() {
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.showInstallButton = true;
    });
  }

  installApp() {
    this.pwaService.installPwa();
    this.showInstallButton = false;
  }
}
